import { AppPageHeader, TabContentWrapper } from '@/components/_common';
import SpaceForButton from '@/components/_common/SpaceForButtons';
import StockTransferList from '@/components/Movements/StockTransfer/StockTransferList';
import { PageProps } from '@/types/PageProps';
import { Button } from 'antd';
import { Helmet } from 'react-helmet';
import { useIntl } from 'react-intl';
import { Link } from 'react-router-dom';

export default function StockTransferPage({ route }: PageProps) {
  const intl = useIntl();

  return (
    <>
      <Helmet title={intl.formatMessage({ id: route.name })} />

      <TabContentWrapper
        permissions={route.permissions}
        title={route.name}
        extra={
          <SpaceForButton>
            <Link to="/app/movements/stock-transfer/create">
              <Button type="primary" block>
                Criar transferência de estoque
              </Button>
            </Link>
          </SpaceForButton>
        }
      >
        <AppPageHeader />

        <StockTransferList />
      </TabContentWrapper>
    </>
  );
}
